import { Component, ErrorInfo, ReactNode } from "react";
import ErrorPage from "@/pages/ErrorPage";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

/**
 * Cattura gli errori di render/lifecycle dei figli e mostra ErrorPage al posto
 * della schermata bianca. Deve restare un class component: React non espone
 * ancora un equivalente a hook.
 *
 * Nota: non intercetta errori in handler async, event handler o fuori da React
 * (per quelli restano i toast e i log lato hook/service).
 */
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("[ErrorBoundary] Crash non gestito:", error, errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
